import type { EventName } from "@lit/react";
import { AppLayout as AppLayoutElement, type AppLayoutEventMap as _AppLayoutEventMap, } from "@vaadin/app-layout/vaadin-app-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { AppLayoutElement, };
export type AppLayoutEventMap = Readonly<{
    onDrawerOpenedChanged: EventName<_AppLayoutEventMap["drawer-opened-changed"]>;
    onOverlayChanged: EventName<_AppLayoutEventMap["overlay-changed"]>;
    onPrimarySectionChanged: EventName<_AppLayoutEventMap["primary-section-changed"]>;
}>;
const events = { onDrawerOpenedChanged: "drawer-opened-changed", onOverlayChanged: "overlay-changed", onPrimarySectionChanged: "primary-section-changed" } as AppLayoutEventMap;
export type AppLayoutProps = WebComponentProps<AppLayoutElement, AppLayoutEventMap>;
export const AppLayout = createComponent({
    elementClass: AppLayoutElement, events, react: React, tagName: "vaadin-app-layout"
});
